import React, { Component } from 'react';
import { ButtonToolbar, Button, Grid, Row, Col, FormGroup, ControlLabel } from 'react-bootstrap';
import Select from "react-select";

export class GlobalParameters extends Component {
    constructor(props) {
        super(props);

        const lineDirections = [
            { value: 0, label: "Automática" },
            { value: 1, label: "Ida" },
            { value: 2, label: "Volta" },
            { value: 3, label: "Circular" },
        ];
        const parameterLineDirection = (undefined === props.parameters || null === props.parameters) ? undefined : lineDirections.find(x => x.value === this.props.parameters.lineDirection);

        this.state = {
            parameters: this.props.parameters,
            form: {
                show: false,
                lineDirection: undefined === parameterLineDirection ? lineDirections[0] : parameterLineDirection,
            },
            lineDirections: lineDirections
        };
    }

    // -----------------------

    onParameterData() {
        const { parameters, form } = this.state;

        const newParameters = {
            lineDirection: null === form.lineDirection ? 0 : form.lineDirection.value
        };

        const baseParameters = (undefined === parameters || null === parameters) ? { id: 0 } : parameters;
        this.props.onParameterData(Object.assign(baseParameters, newParameters), true);
    }

    onChangeCheckboxValue(target) {
        const { form } = this.state;

        form[target] = !form[target];

        this.setState({
            form: form
        });
    }

    onChangeValue(e, target) {
        const { form } = this.state;

        if ("" === e.target.validationMessage) {
            form[target] = e.target.value;
        }

        this.setState({
            form: form
        });
    }

    onSelectValue(e, target) {
        const { form } = this.state;

        form[target] = e;

        this.setState({
            form: form
        });
    }

    // -----------------------

    render() {
        const { form, lineDirections } = this.state;

        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <FormGroup>
                                <ControlLabel className="margin-top-15">Direção da Linha</ControlLabel>
                                <Select
                                    className="custom-multiselect"
                                    placeholder="Direção da Linha"
                                    noOptionsMessage={() => "Sem Direções de Linha Configuradas"}
                                    onChange={(e) => this.onSelectValue(e, "lineDirection")}
                                    options={lineDirections}
                                    isMulti={false}
                                    isClearable={false}
                                    isOptionSelected={function (a) {
                                        return form.lineDirection === a;
                                    }}
                                    getOptionValue={value => value}
                                    getOptionLabel={label => label.label}
                                    value={form.lineDirection} />
                            </FormGroup>
                        </Col>
                    </Row>
                </Grid>

                <ButtonToolbar>
                    <Button bsStyle="default" onClick={() => this.onParameterData()}>GUARDAR</Button>
                    <Button bsStyle="default" onClick={() => this.props.onCancel()}>FECHAR</Button>
                </ButtonToolbar>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/parameters/GlobalParameters.js